// src/api.js
// Единый базовый URL API c принудительным HTTPS и нормализацией пути.
// Ожидается, что значение REACT_APP_API_URL уже содержит префикс /api.

const raw = (process.env.REACT_APP_API_URL || "https://api.radiomonitor.net/api").trim();

function normalizeHttpsBase(url) {
  let u;
  try {
    u = new URL(url);
  } catch {
    throw new Error(`Неверный REACT_APP_API_URL: "${url}"`);
  }
  if (u.protocol !== "https:") {
    throw new Error(`REACT_APP_API_URL должен начинаться с https://, получено: "${u.protocol}"`);
  }
  // убираем лишний хвостовой слэш, но сохраняем /api если он указан
  const base =
    u.origin +
    (u.pathname && u.pathname !== "/" ? u.pathname.replace(/\/+$/, "") : "");
  return base;
}

const API_BASE_URL = normalizeHttpsBase(raw);

export default API_BASE_URL;
